import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/LiveChatActionTypes";
import _ from "lodash";
import Toast from "../../components/assetLibComponents/shared/Toast";
import { appUserActivity } from "./crmActions";

export const setLiveChatUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_CHAT_AI", payload: null });
    };
};

// Fetch external chat Ai asset List

export const fetchLiveConversationListing = (authToken, tabName, key, operator, value, sort, path) => {
  return async (dispatch) => {
    if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/inbox_list",
        {
          inbox_name : tabName,
          limit: 20,
          page:1,
          sorting: sort,
          filter :{
            filter_key:key, //assignee, team, label
            filter_operator: operator, //equal, not_equal
            filter_value: value //all, open, resolved, pending
          }
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_LIVE_CONVERSATION_LISTING,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// Fetch external chat Ai asset List

export const fetchLiveChatListing = (authToken, inbox_id, conversation_id, path, onLiveChatSuccess) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/conversation_list",
        {
          inbox_id : inbox_id,
          conversation_id: conversation_id,
          timezone: "Asia/Kolkata"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_LIVE_CHAT_LISTING,
            payload: response.data,
          });
          onLiveChatSuccess(response.data, path);
          dispatch(appUserActivity(authToken, response.data.lead_id, null));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const sendMessage = (authToken, inbox_id, conversation_id, message, source, onSuccessResponse) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/add_message",
        {
          inbox_id: inbox_id,
          channel_id: "1",
          conversation_id: conversation_id,
          source: source, //chatbot, note
          message: message,
          timezone: "Asia/Kolkata"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          onSuccessResponse()
          // dispatch(fetchLiveChatListing(authToken, inbox_id, conversation_id, "null"))
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchLiveChatAllListing = (authToken) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.get(
        "livechat/livechat_listing",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_ASSIGN_LISTING,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const assignConversationLead = (authToken, payload, newId1, newId2) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/assignee_user",
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          // dispatch(fetchLiveChatListing(authToken, inbox_id, conversation_id, "null"))
          // dispatch(fetchLiveChatListing(authToken, payload.inbox_id, payload.conversation_id, "null"))
          dispatch(getLeadSelectedData(authToken, newId1, newId2));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const createTeam = (authToken, name, desc, agent, id) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/create_team",
        {
          team_id: id,
          team_name: name,
          team_description: desc,
          team_agent: agent,
          status: "1"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchLiveChatAllListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const createLabel = (authToken, name, desc, color, id) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/create_tag",
        {
          tag_id: id,
          tag_name: name,
          tag_description: desc,
          color_code: color,
          status: "1"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchLiveChatAllListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const assignLabel = (authToken, payload) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/assign_tag",
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchLiveChatListing(authToken, payload.inbox_id, payload.conversation_id, "null"))
          dispatch(getLeadSelectedData(authToken, payload.inbox_id, payload.conversation_id, "null"))
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const getLeadSelectedData = (authToken, id1, id2) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/assignee_detail",
        {
          inbox_id: id1,
          conversation_id: id2
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: "LEAD_SELECTED_DATA",
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchChatStatus = (authToken, id1, id2, status) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/ticket_status",
        {
          inbox_id: id1,
          conversation_id: id2,
          status: status
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchLiveChatListing(authToken, id1, id2, "null"))
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchAiAssist = (authToken, id1, id2, message, action, onSuccess, onFailure) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "livechat/create_assist",
        {
          inbox_id: id1,
          conversation_id: id2,
          message: message,
          action: action
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          onFailure();
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          onSuccess(response.data?.ai_response);
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      onFailure();
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchSearchList = (authToken, search, action, page, limit, onSuccessSearch, onFailureSearch) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "livechat/live_search",
        {
          search: search,
          action: action.toLowerCase(), //all, contacts, messages
          page: page,
          limit: limit
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          onFailureSearch();
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          let act = action?.toLowerCase();
          onSuccessSearch(act !== "contacts" ? response.data?.data?.messages : response.data?.data?.contacts, response?.data?.count);
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      onFailureSearch();
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

//Add Contact
export const addLeads = (authToken, newContact, id1, id2) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "crm/add_lead",
                newContact,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    dispatch({
                        type: "UNAUTHORIZED_CRM",
                        payload: response.data.statusCode,
                    });
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else if (response.data.statusCode == "200") {
                    dispatch(fetchLiveChatListing(authToken, id1, id2, "lead"));
                    // Toast(response.data.message, "S");
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    Toast(response.data.message, "E");
                }
                dispatch({ type: "TOGGLE_LOADING", payload: false });
            }
        } catch (err) {
            // Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CRM", payload: err.response.status });
        }
    };
};

//edit lead details data
export const editUserData = (authToken,id,payload, comName, comWebsite, id1, id2) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "crm/add_lead",
                {
                    action: "edit",
                    lead_id: id,
                    company_name: comName,
                    company_website: comWebsite,
                    response: payload,
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CRM",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     // Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    dispatch({
                        type: "DETAIL_UPDATED_DATA",
                        payload: response.data.details,
                    })
                    dispatch(fetchLiveChatListing(authToken, id1, id2, "lead"));
                    // Toast(response.data.message, "S");
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            // Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CRM", payload: err.response.status });
        }
    };
};

//edit lead details data
export const agentStatusUpdate = (authToken, status) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "livechat/agent_status",
                {
                    status: status
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CRM",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     // Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    dispatch(fetchLiveChatAllListing(authToken));
                    // Toast(response.data.message, "S");
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            // Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CRM", payload: err.response.status });
        }
    };
};


export const fetchCannedListing = (authToken,type , short_code) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "livechat/list_can_response",
        {
          type: type, //self, admin
          short_code: short_code
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_CANNED_LISTING,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};


export const createCannedResponse = (authToken, name, desc, id) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/add_can_response",
        {
          cr_id: id || null,
          short_code: name,
          message: desc
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchCannedListing(authToken , 'self', null));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const removeCannedResponse = (authToken, id) => {
  return async (dispatch) => {
    // if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "livechat/remove_can_response",
        {
          cr_ids: [id] 
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchCannedListing(authToken , 'self', null));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};